import React from 'react';
import { Box, Container,Link, Typography, Stack, Divider, Toolbar } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';

import { grey } from '@mui/material/colors';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div>
    <Toolbar sx={{ 
      borderTop: 1, 
      borderColor: 'divider',
      alignItems: 'center', 
      display: 'flex',
      backgroundColor: 'white' // Add background color to ensure footer is visible
    }}>
          <Container maxWidth="md">
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
        mb={1}
      >
        <Link
          href="mailto:support@arealit.ca"
          color="inherit"
          sx={{ display: 'flex', alignItems: 'center', color: grey[600] }}
        >
          <EmailIcon />
        </Link>
        <Divider orientation="vertical" flexItem />
        <Link
          href="https://www.facebook.com/profile.php?id=61573195690349"
          color="inherit"
          sx={{ display: 'flex', alignItems: 'center', color: grey[600] }}
        >
          <FacebookIcon />
        </Link>
      </Stack>
      <Typography variant="body2" color={grey[600]} align="center">
        © {currentYear} Crew Bank. All rights reserved.
      </Typography>
      </Container>
      </Toolbar>
      </div>
  );
};

export default Footer;
